import type { PermissionSensitivity } from '@/api/permissions'

export type SensitivityBadgeCfg = { color: string; variant: 'light' | 'filled'; label: string }

// Cores semanticas do DESIGN_SYSTEM.md (secao 2): `red` e' Danger; `filled`
// e' o tom de acao destrutiva. `critical` fica acima de `sensitive` no mesmo
// vermelho, preenchido, para nao ser lido como mais um "Sensivel".
const SENSITIVITY_BADGE: Record<PermissionSensitivity, SensitivityBadgeCfg> = {
  read:      { color: 'gray', variant: 'light',  label: '◷ Leitura' },
  write:     { color: 'blue', variant: 'light',  label: '✎ Escrita' },
  sensitive: { color: 'red',  variant: 'light',  label: '⚠ Sensível' },
  critical:  { color: 'red',  variant: 'filled', label: '⚠ Crítica' },
}

/** Selo da sensibilidade. Valor desconhecido cai em `sensitive`, nunca em
 *  `read`: na duvida, o selo exagera o perigo em vez de esconde-lo. */
export function sensitivityBadge(sensitivity: string): SensitivityBadgeCfg {
  return SENSITIVITY_BADGE[sensitivity as PermissionSensitivity] ?? SENSITIVITY_BADGE.sensitive
}
